export default __webpack_public_path__ + "static/media/Bracers of Wild Furor.b1884871.jpg";